import * as React from "react";
import {
  Card,
  CardContent,
  Autocomplete,
  Typography,
  CardActions,
  Button,
  Box,
  FormControl,
  MenuItem,
  FormControlLabel,
  Radio,
  OutlinedInput,
  InputLabel,
  Alert,  Stack,
  Chip,
} from "@mui/material";
import { Formik, FormikProps, Form } from "formik";
import TextField from "@mui/material/TextField";
import * as Yup from "yup";
import { Link, useMatch } from "react-router-dom";
import RadioGroup from "@mui/material/RadioGroup";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../store/store";
import { roleGetData, roleSelector } from "../../../store/slices/roleSlice";
import {
  businessGetData,
  businessSelector,
} from "../../../store/slices/businessSlice";
import {
  roleActionSelector,
  roleGetDataById,
  roleUpdateData,
} from "../../../store/slices/roleActionSlice";
import { Role } from "../../../types/role.type";
import { priceLevelSelector, priceLevelGetData } from "../../../store/slices/priceLevelSlice";
import { menuGetDataList, menuListSelector } from "../../../store/slices/menuListSlice";
import { siteGetData, siteSelector } from "../../../store/slices/siteSlice";
import Loader from "../../component/Loader";
import CheckIcon from "@mui/icons-material/Check";
import { Theme, useTheme } from '@mui/material/styles';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { createAsyncThunk} from "@reduxjs/toolkit";
import { httpClient } from "../../../utils/httpclient";
import { server } from "../../../Constants";
import { Site } from "../../../types/site.type";
import { Menu } from "../../../types/menu.type";
import { PriceLevel } from "../../../types/pricelevel.type";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

type RoleEditPageProps = {
  //
};

const RoleEditPage: React.FC<any> = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const bisinessReducer = useSelector(businessSelector);
  const priceLevelReducer = useSelector(priceLevelSelector);
  const roleActionReducer = useSelector(roleActionSelector);
  const menuListReducer = useSelector(menuListSelector);
  const siteReducer = useSelector(siteSelector);
  const match = useMatch("/role/edit/:id");
  const [selectedNames, setSelectedNames] = React.useState([]);
  const theme = useTheme();
  const [personName, setPersonName] = React.useState<string[]>([]);
  const [petInputValue, setPetInputValue] = React.useState("");
  const [selectedSite, setSelectedSite] =  React.useState<any>([]);
  const [menuInputValue, setMenuInputValue] = React.useState("");
  const [selectedMenu, setSelectedMenu] =  React.useState<any>([]);
  const [buInputValue, setBUInputValue] = React.useState("");
  const [selectedBU, setSelectedBU] =  React.useState<any>([]);
  const [priceLevelInputValue, setpriceLevelInputValue] = React.useState("");
  const [selectedpriceLevel, setSelectedpriceLevel] =  React.useState<any>([]);
  const [roleTypeInputValue, setroleTypeInputValue] = React.useState("");
  const [selectedroleType, setSelectedroleType] =  React.useState<any>([]);
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const MySwal = withReactContent(Swal);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const initialValues: Role = {
    roleId: '',
    roleName: '',
    buId: '',
    priceLevel: [],
    menu: [],
    roleType: '',
    site: [],
    active: true,
    createdBy: '',
    remark:'',
  };

  function getStyles(name: string, personName: readonly string[], theme: Theme) {
    return {
      fontWeight:
        personName.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }

  React.useEffect(() => {
    dispatch(businessGetData(""));
    dispatch(menuGetDataList());
    dispatch(priceLevelGetData(""));
    dispatch(siteGetData(""));
  }, []);

  React.useEffect(() => {
    let id = match?.params.id;
    dispatch(roleGetDataById(id!));
    dispatch(roleGetDataByIdSelected(id!));

    
  }, []);
  // const setName = (value:any) => {
  //  let iname = siteReducer.result.map((item) => (item.id = value)   
  //  setSelectedNames(iname[0].siteName!);   
  // };

const roleGetDataByIdSelected = createAsyncThunk(
    "role/getrole",
    async (id: string, thunkApi) => {
        try {
            const result = await httpClient.get<Role>(`${server.ROLE_URL}/${id}`);

            let keyword="";
            const resultSite = await httpClient.get<Site[]>(server.SITE_URL + "?keyword=" + keyword);
            let listSite:Site[]=[];
    
            if(result!){        
                for (let x = 0; x < result.data.site.length; x += 1) {
                let getSite = resultSite.data.find((j) => j.id! === result.data.site[x]!);
                listSite.push(getSite!);
              }
              setSelectedSite(listSite);
            }

            const resultPriceLevel = await httpClient.get<PriceLevel[]>(server.PRICELEVEL_URL + "?keyword=" + keyword);
            let listPriceLevel:PriceLevel[]=[];
    
            if(result!){        
                for (let x = 0; x < result.data.priceLevel.length; x += 1) {
                let getData = resultPriceLevel.data.find((j) => j.id! === result.data.priceLevel[x]!);
                listPriceLevel.push(getData!);
              }
              setSelectedpriceLevel(listPriceLevel);
            }

            const resultMenuList = await httpClient.get<Menu[]>(server.MENU_URL + "/data/list");
            let listMenu:Menu[]=[];
    
            if(result!){        
                for (let x = 0; x < result.data.menu.length; x += 1) {
                let getData = resultMenuList.data.find((j) => j.menuId! === result.data.menu[x]!);
                listMenu.push(getData!);
              }
              setSelectedMenu(listMenu);
            }

             return result;
        } catch (error: any) {
            let err = error.response.data.message ?? error.message
            return thunkApi.rejectWithValue(err);
        }
    }
);


  const handleChangeSite = (event: SelectChangeEvent<typeof personName>) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const showForm = ({
    values,
    setFieldValue,
    isSubmitting,
    touched,
    errors,
    handleChange,
    handleBlur,
  }: FormikProps<Role>) => {
    return (
      <Form>
        <Card>
          <CardContent sx={{ padding: 4 }}>
            <Typography gutterBottom variant="h5">
              Edit role
            </Typography>

            <TextField
              id="roleName"
              style={{ marginTop: 16 }}
              fullWidth
              variant="outlined"
              label={t("roleName")}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.roleName}
              helperText={
                errors.roleName && touched.roleName
                  ? errors.roleName
                  : ""
              }
              error={errors.roleName && touched.roleName ? true : false}
            /> 

            <FormControl style={{ marginTop: 16 }} fullWidth>
              {/* <InputLabel htmlFor="buId">{t("selectBu")}</InputLabel> */}
              <Select
                name="buId"
                // autoWidth
                value={values.buId}
                onChange={(event) =>
                  setFieldValue("buId", event.target.value)
                }
                error={errors.buId && touched.buId ? true : false}
              >
                {bisinessReducer.result.map((item, index) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.buName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl style={{ marginTop: 16 }}fullWidth >
            <Autocomplete
                  multiple
                  id="priceLevel1"
                  options={priceLevelReducer.result}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.priceLevelDesc}
                    </li>
                  )}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.priceLevelDesc}
                  inputValue={priceLevelInputValue}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  onInputChange={(event, newPriceLevelInputValue) => {
                    setpriceLevelInputValue(newPriceLevelInputValue);
                  }}
                  value={selectedpriceLevel}
                  onChange={(event, newValue) => {
                    setSelectedpriceLevel(newValue);
                    // console.log("check select site :" + newValue);
                  }}

                  style={{ width: '100%' }}
                  renderInput={(params) => (
                    <TextField {...params} label={t("select_PriceLevel")} placeholder="Search" />
                  )}
                />
              </FormControl>

            {/* <FormControl style={{ marginTop: 16 }} fullWidth>
              <InputLabel htmlFor="priceLevel">{t('select_PriceLevel')}</InputLabel>
              <Select
                multiple
                MenuProps={MenuProps}
                name="priceLevel"
                autoWidth
                value={values.priceLevel}
                input={<OutlinedInput label="select_PriceLevel" />}
              
                label={t("select_PriceLevel")}
                onChange={handleChange}
         

              >
                {priceLevelReducer.result.map((item, index) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.priceLevelDesc}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}

            <FormControl style={{ marginTop: 16 ,width: '99.99%'}} >
            <Autocomplete
                  multiple
                  id="siteCode1"
                  options={siteReducer.result}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.siteName}
                    </li>
                  )}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.siteName}
                  inputValue={petInputValue}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  onInputChange={(event, newPetInputValue) => {
                    setPetInputValue(newPetInputValue);
                  }}
                  value={selectedSite}
                  onChange={(event, newValue) => {
                    setSelectedSite(newValue);
                    // console.log("check select site :" + newValue);
                  }}

                  style={{ width: '100%' }}
                  renderInput={(params) => (
                    <TextField {...params} label={t('siteCode')} placeholder="Search" />
                  )}
                />
              </FormControl>

{/* 
            <FormControl style={{ marginTop: 16}}fullWidth >
              <InputLabel htmlFor="site">{t('select_site')}</InputLabel>
              <Select
                multiple
           
                name="site"
                value={values.site }
                input={<OutlinedInput label="select_site" />}
     
                label={t("select_site")}
                onChange={handleChange}
     
              >
                {siteReducer.result.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.siteName}
           
                  </MenuItem>

                ))}
              </Select>
            </FormControl> */}

            <FormControl style={{ marginTop: 16 ,width: '99.99%'}} >
            <Autocomplete
                  multiple
                  id="menu1"
                  options={menuListReducer.result.filter(x => x.parentId !== null && x.parentId !== '')
                  }
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.menuName}
                    </li>
                  )}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.menuName}
                  inputValue={menuInputValue}
                  isOptionEqualToValue={(option, value) => option.menuId === value.menuId}
                  onInputChange={(event, newMenuInputValue) => {
                    setMenuInputValue(newMenuInputValue);
                  }}
                  value={selectedMenu}
                  onChange={(event, newValue) => {
                    setSelectedMenu(newValue);
                    // console.log("check select site :" + newValue);
                  }}

                  style={{ width: '100%' }}
                  renderInput={(params) => (
                    <TextField {...params} label={t("select_Menu")} placeholder="Search" />
                  )}
                  
                />
              </FormControl>

            {/* <FormControl style={{ marginTop: 16 }} fullWidth>
              <InputLabel htmlFor="menu">{t('select_Menu')}</InputLabel>
              <Select
                multiple
                MenuProps={MenuProps}
                name="menu"
                autoWidth
                value={values.menu}
                input={<OutlinedInput label="select_Menu" />}
       
                label={t("select_Menu")}
                onChange={handleChange}

              >


                {menuListReducer.result.filter(x => x.parentId !== null && x.parentId !== '').map((item, index) => (
                  <MenuItem key={item.menuId} value={item.menuId}>
                    {item.menuName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}


            <FormControl style={{ marginTop: 16 }} fullWidth>
              <InputLabel htmlFor="roleType">{t('select_roleType')}</InputLabel>
              <Select
                MenuProps={MenuProps}
                name="roleType"
                // autoWidth
                value={values.roleType}
                input={<OutlinedInput label="select_roleType" />}
                // onChange={handlepricelevelChange}
                label={t("select_roleType")}
                onChange={handleChange}
              >
                <MenuItem value={"ADMIN"}>{t('select_admin')}</MenuItem>
                <MenuItem value={"MARKETING"}>{t('select_marketing')}</MenuItem>
                <MenuItem value={"BRANCH"}>{t('select_branch')}</MenuItem>
              </Select>
            </FormControl>
            <TextField
              name="remark"
              style={{ marginTop: 16 }}
              fullWidth
              variant="outlined"
              label={t("remark")}
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                errors.remark 
                  ? errors.remark
                  : ""
              }
              error={errors.remark  ? true : false}
            />

            <FormControl component="fieldset" style={{ marginTop: 16 }} fullWidth>
              <RadioGroup row name="active" onChange={(event) => { setFieldValue("active", event.currentTarget.value === "true" ? true : false) }} value={values.active}>
                <FormControlLabel control={<Radio />} value={true} label={t('active')} />
                <FormControlLabel control={<Radio />} value={false} label={t('inactive')} />
              </RadioGroup>
            </FormControl>

            {roleActionReducer.isError && (
              <Alert severity="error">{roleActionReducer.message}</Alert>
            )}
          </CardContent>
          <CardActions>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              type="submit"
              sx={{ marginRight: 1 }}
              disabled={roleActionReducer.isFetching}
            >
              {t('btnEdit')}
            </Button>
            <Button component={Link} to="/role" variant="outlined" fullWidth>
              {t('btnCancel')}
            </Button>
          </CardActions>
        </Card>
      </Form>
    );
  };

  const inputRequired = t('inputRequired');
  const validationSchema = Yup.object().shape({
    roleName: Yup.string().required(inputRequired),
    remark: Yup.string().required(inputRequired),
    // priceLists: Yup.string().required(),
    // createdBy: Yup.string().required(),
    // menu: Yup.string().required(),
    // status: Yup.boolean().required(),
  });


  if (roleActionReducer.isFetching) {
    return <><Loader /></>
  }


  return (
    <Box>
      <Formik
        validationSchema={validationSchema}
        enableReinitialize={true}
        initialValues={
          roleActionReducer.result ? roleActionReducer.result! : initialValues
        }
        onSubmit={(values, { setSubmitting }) => {


          let selectSite=[]
          for (let iSite of selectedSite) {
            selectSite.push(iSite.id)
          }

          let selectPriceLevel=[]
          for (let x of selectedpriceLevel) {
            selectPriceLevel.push(x.id)
          }

          let selectMenu=[]
          for (let x of selectedMenu) {
            selectMenu.push(x.menuId)
          }

          // console.log("selectedSite: " + selectedSite.length);
          // console.log(selectSite);
          // console.log("selectedpriceLevel: " + selectedpriceLevel.length)
          // console.log(selectPriceLevel)
          // console.log("selectedMenu: " + selectedMenu.length)
          // console.log(selectMenu)

          const newValues ={
            ...values,
            site:selectSite,
            // roleType:selectedroleType,
            priceLevel:selectPriceLevel,
            menu:selectMenu,
          }
          if( selectSite.length === 0 || selectPriceLevel.length ===0 || selectMenu.length===0){
            MySwal.fire({
              title: <p>กรุณาเลือก SiteCode หรือ PriceLevel หรือ Menu</p>,
              didOpen: () => {
                // `MySwal` is a subclass of `Swal` with all the same instance & static methods
              },
            });
          }
          else {
          //console.log(values);
          dispatch(roleUpdateData(newValues));
          setSubmitting(false);
          }
        }}
      >
        {(props: any) => showForm(props)}
      </Formik>
    </Box>
  );
};

export default RoleEditPage;
